module.exports = __webpack_public_path__ + "static/img/file_cover.007170a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/file_cover.png
// module id = XlKx
// module chunks = 1